import { Link } from "react-router-dom";
import React, { useState } from "react";
import { Card, CardBody, Col, Nav, NavItem, NavLink, Row } from "reactstrap";
import { pricing2 } from "../../../../common/data";
import classnames from "classnames";

export default function Step2({
  activeTab,
  setActiveTab,
  setChosenPlan,
  chosenPlan,
  seatsSelected,
  setSeatsSelected,
}) {
  const [activeTabPricePlan, setActiveTabPricePlan] = useState("1");
  return (
    <>
      <Row className="justify-content-center mt-4">
        <Col lg={5}>
          <div className="text-center mb-4">
            <h4 className="fw-semibold fs-22">Enter seat number</h4>
            <p className="text-muted mb-4 fs-15">
              Simple pricing. No hidden fees. Advanced features for you
              business.
            </p>

            <div className="d-inline-flex">
              <Nav
                className="nav-pills arrow-navtabs plan-nav rounded mb-3 p-1"
                id="pills-tab"
                role="tablist"
              >
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames(
                      { active: activeTabPricePlan === "1" },
                      "fw-semibold"
                    )}
                    onClick={() => {
                      setActiveTabPricePlan("1");
                    }}
                  >
                    Monthly
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames(
                      { active: activeTabPricePlan === "2" },
                      "fw-semibold"
                    )}
                    onClick={() => {
                      setActiveTabPricePlan("2");
                    }}
                  >
                    Annually <span className="badge bg-success">25% Off</span>
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        {(chosenPlan || [])?.map((price2, key) => (
          <Col lg={4} key={key}>
            <Card className="pricing-box ribbon-box right">
              {price2?.ribbon === true ? (
                <div className="ribbon-two ribbon-two-danger">
                  <span>Popular</span>
                </div>
              ) : (
                ""
              )}
              <CardBody className="p-4 m-2">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <h5 className="mb-1 fw-semibold">{price2?.type}</h5>
                    <p className="text-muted mb-0">{price2.purpose}</p>
                  </div>
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-primary">
                      <i className={"fs-20 " + price2.icon}></i>
                    </div>
                  </div>
                </div>
                <div className="pt-2 ">
                  <h3 className={"d-flex align-items-center"}>
                    <small>£ </small>

                    {activeTabPricePlan === "2" ? (
                      <div className={"pe-1"}>
                        <del>{price2?.rate}</del>{" "}
                        {(Number(price2?.rate) / 1.25).toFixed(2)}{" "}
                      </div>
                    ) : (
                      <> {price2?.rate}</>
                    )}

                    <span className="fs-13 text-muted">/Month</span>
                  </h3>
                </div>
                <hr className="my-4 text-muted" />
                <div>
                  <ul className="list-unstyled text-muted vstack gap-3">
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-success me-1">
                          <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                        </div>
                        <div className="flex-grow-1">
                          Upto <b>{price2.projects}</b> Projects
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-success me-1">
                          <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                        </div>
                        <div className="flex-grow-1">
                          Upto <b>{price2.Customers}</b> Customers
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-success me-1">
                          <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                        </div>
                        <div className="flex-grow-1">Scalable Bandwidth</div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-success me-1">
                          <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                        </div>
                        <div className="flex-grow-1">
                          <b>{price2.FTP}</b> FTP Login
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div
                          className={`flex-shrink-0 text-${price2.supportClass} me-1`}
                        >
                          <i
                            className={`ri-${price2.supportClassSymbol}-circle-fill fs-15 align-middle`}
                          ></i>
                        </div>
                        <div className="flex-grow-1">
                          <b>24/7</b> Support
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div
                          className={`flex-shrink-0 text-${price2.storageClass} me-1`}
                        >
                          <i
                            className={`ri-${price2?.storageClassSymbol}-circle-fill fs-15 align-middle`}
                          ></i>
                        </div>
                        <div className="flex-grow-1">
                          <b>Unlimited</b> Storage
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div
                          className={`flex-shrink-0 text-${price2?.domainClass} me-1`}
                        >
                          <i
                            className={`ri-${price2?.domainClassSymbol}-circle-fill fs-15 align-middle`}
                          ></i>
                        </div>
                        <div className="flex-grow-1">Domain</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
        <Col lg={4}>
          <Card className="pricing-box ribbon-box right">
            <div className={"p-3"}>
              <div className={"pt-2"}>
                <h5 className="mb-1 fw-semibold">
                  How many seats do you require ?
                </h5>
              </div>
              <div className={"d-flex align-items-center pt-2 pb-2"}>
                <i className="fa-solid fa-couch ps-1 pe-2"></i>

                <input
                  type="number"
                  placeholder="Number of seats"
                  className={"form-control"}
                  value={seatsSelected}
                  onChange={(e) => {
                    setSeatsSelected(e.target.value);
                  }}
                />
              </div>
              <div className={"pt-2 pb-2"}>
                Total <i className="fa-solid fa-couch ps-1 pe-1"></i> selected{" "}
                {seatsSelected}
              </div>
              <div>
                {" "}
                {activeTabPricePlan === "2" ? (
                  <>
                    Total Annual Cost £
                    {(
                      Number(chosenPlan[0]?.rate) *
                      Number(seatsSelected) *
                      12
                    ).toFixed(2)}
                  </>
                ) : (
                  <>
                    Total Monthly Cost £
                    {(
                      Number(chosenPlan[0]?.rate) * Number(seatsSelected)
                    ).toFixed(2)}
                  </>
                )}
              </div>
              <div className="mt-4">
                <Link
                  to="#"
                  className={`btn btn-success w-100 waves-effect waves-light`}
                  onClick={() => {
                    setActiveTab(3);
                  }}
                >
                  Confirm Seats required
                </Link>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
}
